module.exports = __webpack_public_path__ + "img/cta-appstore.ba7eddb9.svg";